import React from "react";
import { CCol, CRow } from "@coreui/react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

// Validation schema using Yup
const validationSchema = Yup.object({
  feedback_reason: Yup.string().required("Reason for Feedback is required"),
  name: Yup.string().required("Name is required"),
  organization: Yup.string().required("Organization is required"),
  phone: Yup.string().required("Phone Number is required"),
  role: Yup.string().required("Role is required"),
  participant_name: Yup.string().required("Participant Name is required"),
  address: Yup.string().required("Address is required"),
  funding_body: Yup.string().required("Funding Body is required"),
  services_accessed: Yup.string().required("Services Accessed is required"),
  participant_date: Yup.date().required(
    "Date of Services Accessed is required"
  ),
  participant_fullname: Yup.string().required(
    "Full Name of Participant is required"
  ),
  staffName: Yup.string().required("Name of Staff/Provider is required"),
  feedback_details: Yup.string().required("Feedback Details are required"),
  actions_taken: Yup.string().required("Actions Taken is required"),
});

export default function FeedbackForm() {
  const handleSubmit = (values, { resetForm }) => {
    // Prepare the data to be sent to the server
    const data = {
      feedback_reason: values.feedback_reason,
      name: values.name,
      organization: values.organization,
      phone: values.phone,
      role: values.role,
      participant_name: values.participant_name,
      address: values.address,
      funding_body: values.funding_body,
      services_accessed: values.services_accessed,
      participant_date: values.participant_date,
      participant_fullname: values.participant_fullname,
      staffName: values.staffName,
      feedback_details: values.feedback_details,
      actions_taken: values.actions_taken,
    };

    // Use Axios to send a POST request
    axios
      .post("https://erp.rplconsultants.com.au/api/feedback", data)
      .then((response) => {
        // On success, show an alert and reset the form
        alert("Feedback submitted successfully!");
        resetForm();
      })
      .catch((error) => {
        // Handle error
        console.error("Error submitting feedback:", error);
        alert("There was an error submitting the feedback. Please try again.");
      });
  };

  return (
    <Formik
      initialValues={{
        feedback_reason: "",
        feedback_date: "",
        name: "",
        organization: "",
        phone: "",
        role: "",
        participant_name: "",
        address: "",
        funding_body: "",
        participant_date: "",
        provider_name: "",
        staffName: "",
        feedback_details: "",
        actions_taken: "",
        participant_fullname: "",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form>
          <CRow>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>Reason for Feedback</label>
                <Field as="select" name="feedback_reason">
                  <option value="">Select Reason</option>
                  <option value="Complaint">Complaint</option>
                  <option value="Suggestion">Suggestion</option>
                  <option value="Compliment">Compliment</option>
                </Field>
                <ErrorMessage
                  name="feedback_reason"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <div className="mb-3 mt-4">
              <h6 className="form-heading">
                Details of Person Providing Feedback
              </h6>
            </div>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="participant_fullname"
                  placeholder="Full Name of Participant"
                />
                <ErrorMessage
                  name="participant_fullname"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="name" placeholder="Name" />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="organization"
                  placeholder="Organization"
                />
                <ErrorMessage
                  name="organization"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="phone" placeholder="Phone Number" />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>Role</label>
                <Field as="select" name="role">
                  <option value="">Select Role</option>
                  <option value="Participant">Participant</option>
                  <option value="Family Member">Family Member</option>
                  <option value="Representative">Representative</option>
                  <option value="Carer">Carer</option>
                  <option value="Worker">Worker</option>
                </Field>
                <ErrorMessage
                  name="role"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <div className="mb-3 mt-4">
              <h6 className="form-heading">Participant Details</h6>
            </div>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="participant_name" placeholder="Name" />
                <ErrorMessage
                  name="participant_name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="address" placeholder="Address" />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  as="textarea"
                  name="funding_body"
                  rows={5}
                  placeholder="Funding Body"
                />
                <ErrorMessage
                  name="funding_body"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="services_accessed"
                  placeholder="Services Accessed"
                />
                <ErrorMessage
                  name="services_accessed"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="date" name="participant_date" />
                <ErrorMessage
                  name="participant_date"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <div className="mb-3 mt-4">
              <h6 className="form-heading">Details of Feedback</h6>
            </div>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="staffName"
                  placeholder="Name if staff / provider"
                />
                <ErrorMessage
                  name="staffName"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  as="textarea"
                  name="feedback_details"
                  rows={5}
                  placeholder="Details if feedback"
                />
                <ErrorMessage
                  name="feedback_details"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  as="textarea"
                  name="actions_taken"
                  rows={5}
                  placeholder="Actions taken"
                />
                <ErrorMessage
                  name="actions_taken"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={12} className="mt-4">
              <div className="form-submit">
                <button type="submit" className="theme-primary-btn">
                  Submit
                </button>
              </div>
            </CCol>
          </CRow>
        </Form>
      )}
    </Formik>
  );
}
